<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			<v-form ref="form">
				{{ text }}
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],
}
</script>
